import { Box } from '@material-ui/core';
import { Layout } from '@roc/feature-app-core';
import { FilterButton, Tabs } from '@roc/ui';
import { observer } from 'mobx-react';
import React, { useEffect, useState } from 'react';
import { useStore } from '@roc/client-portal-shared/hooks';
import { ClosingConditionsTasksGrid } from './closingConditionsDashboardTasksGrid';
import { PostClosingConditionsTasksGrid } from './postClosingConditionsDashboardTasksGrid';
import { ClosingConditionTab } from '../../stores/closingConditionsDashboardStore';
import { InformationDialog } from '@roc/ui';

const TABS = [
  { label: 'MY CLOSING CONDITIONS' },
  { label: 'MY TEAM CLOSING CONDITIONS' },
  { label: 'ALL CLOSING CONDITIONS' },
  { label: 'POST-CLOSING CONDITIONS' },
];

const TAB_MAP = [
  ClosingConditionTab.MY_CLOSING_CONDITIONS,
  ClosingConditionTab.MY_TEAM_CLOSING_CONDITIONS,
  ClosingConditionTab.ALL_CLOSING_CONDITIONS,
  ClosingConditionTab.POST_CLOSING_CONDITIONS,
];

export const BrowseClosingConditionsTasks = observer(() => {
  const [selectedTab, setSelectedTab] = useState(0);
  const { closingConditionsDashboardStore } = useStore();

  const onTabChange = (e: any, index: number) => {
    setSelectedTab(index);
    closingConditionsDashboardStore.setCurrentTab(TAB_MAP[index]);
  };

  const handleToggleFilter = () => {
    closingConditionsDashboardStore.closingConditionsGridStore.toggleFilters();
  };

  const handleClearFilter = () => {
    closingConditionsDashboardStore.closingConditionsGridStore.resetFilters();
  };

  useEffect(() => {
    closingConditionsDashboardStore.setCurrentTab(TAB_MAP[selectedTab]);
  }, []);

  const isPostClosingTab = TAB_MAP[selectedTab] === ClosingConditionTab.POST_CLOSING_CONDITIONS;

  return (
    <Layout title="Closing Conditions">
      <Tabs
        tabs={TABS}
        selectedTab={selectedTab}
        onTabChange={onTabChange}
        right={
          <Box py={1} pr={2}>
            <FilterButton
              onToggleFilters={handleToggleFilter}
              onClearFilters={handleClearFilter}
            />
          </Box>
        }
      />
      {isPostClosingTab ? <PostClosingConditionsTasksGrid /> : <ClosingConditionsTasksGrid />}
    </Layout>
  );
});